export default "__VITE_ASSET__C3Zbxe4V__"